// The admin dashboard's sales chart (AdminDashboardScreen): the date range behind each of
// its five range buttons, and the chart's rows, one per day of the range with that day's
// sales or 0. The backend groups the orders by their day in Europe/Berlin as dd.mm.yyyy
// (GET /api/orders/summary), so the rows label their days the same way.

export const getSalesDateRange = (range) => {
  const now = new Date();

  switch (range) {
    case 'currentMonth':
      return {
        startDate: new Date(now.getFullYear(), now.getMonth(), 1),
        endDate: now, // today
      };
    case 'lastMonth':
      return {
        startDate: new Date(now.getFullYear(), now.getMonth() - 1, 1),
        endDate: new Date(now.getFullYear(), now.getMonth(), 0), // last day of last month
      };
    case 'currentYear':
      return {
        startDate: new Date(now.getFullYear(), 0, 1),
        endDate: now, // today
      };
    case 'lastYear':
      return {
        startDate: new Date(now.getFullYear() - 1, 0, 1),
        endDate: new Date(now.getFullYear() - 1, 11, 31), // Dec 31 of last year
      };
    case 'allTime':
      return {
        startDate: new Date(2025, 0, 1),
        endDate: now,
      };
    // no default
  }
}; // the first and the last day of a range button's period; the range buttons and the screen's first state send one of the five (the days are local, the labels Berlin's: see salesDateFormat)

const getAllDates = (start, end) => {
  const dates = [];
  let dt = new Date(start);

  while (dt <= end) {
    dates.push(new Date(dt));
    dt.setDate(dt.getDate() + 1);
  }
  return dates;
}; // Generates a list of dates

const salesDateFormat = new Intl.DateTimeFormat('de-DE', {
  timeZone: 'Europe/Berlin',
  year: 'numeric',
  month: '2-digit',
  day: '2-digit',
}); // Formats a date as dd.mm.yyyy; built once, as a formatter per day cost 31 ms per render of the dashboard at "All time"

export const mergeDailySales = (dailyOrders, startDate, endDate) => {
  const salesMap = new Map(dailyOrders.map((x) => [x._id, x.sales])); // Creates a map of sales data for easy lookup

  return getAllDates(startDate, endDate).map((date) => {
    const dateStr = salesDateFormat.format(date);
    return [dateStr, salesMap.get(dateStr) || 0]; // Use 0 if there are no sales data for this date
  }); // Merges date range with sales data
}; // the chart's rows: [day label, that day's sales] for every day of the range
